import { url } from "web/services/regex"

import ViewerLink from "./ViewerLink"

function sanitizeUrl(url) {
  const hasAllowedProtocol =
    url.toLowerCase().startsWith("http://") ||
    url.toLowerCase().startsWith("https://")

  return hasAllowedProtocol ? url : `https://${url}`
}

export default function URLViewer({ value, showLinkIcon, truncateValue }) {
  return (
    <ViewerLink
      href={sanitizeUrl(value.value)}
      label={value.value}
      showLinkIcon={showLinkIcon}
      truncateValue={truncateValue}
    />
  )
}

URLViewer.isViewerFor = (x) => x.kind === "Text" && url.test(x.value)
